import { Box, Typography } from '@mui/material';
import { format, isValid, parse } from 'date-fns';
import { useState } from 'react';
import {
  Bar,
  BarChart as ReBarChart,
  CartesianGrid,
  Cell,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';

import { CardProps } from './common';
import { ChartCardContainer } from './styled';

type BarChartProps = {
  card: CardProps;
  small?: boolean;
};

export const formatAxisDate = (v: string) => {
  const d = parse(v, 'yyyy-MM-dd', new Date());
  return isValid(d) ? format(d, 'MMM d') : v;
};

export const BarChart = ({ card, small = false }: BarChartProps) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  return (
    <ChartCardContainer small={small}>
      <Typography variant="body2" color="#9CA0A2" mb="12px">
        {card.title}
      </Typography>
      <Typography fontSize={30} fontWeight={700}>
        {`${card.value}/7 days`}
      </Typography>

      <Box height={small ? '175px' : '200px'} mt={small ? '12px' : '37px'}>
        <ResponsiveContainer width="100%" height="100%">
          <ReBarChart data={card?.chartData ?? []} onMouseLeave={() => setActiveIndex(null)}>
            <CartesianGrid vertical={false} horizontal={false} />
            <XAxis
              dataKey="date"
              interval={0}
              minTickGap={0}
              tickFormatter={formatAxisDate}
              tick={{ fill: '#9CA0A2', fontSize: 10 }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis hide domain={['dataMin - 10', 'dataMax + 10']} />
            <Bar
              dataKey="count"
              radius={[1, 1, 0, 0]}
              onMouseOver={(_, index) => setActiveIndex(index)}
            >
              {card.chartData?.map((_, index) => (
                <Cell key={`cell-${index}`} fill={index === activeIndex ? '#39CA88' : '#424A6D'} />
              ))}
              <LabelList
                dataKey="count"
                content={(props) => {
                  const { x, y, value, index, width } = props as {
                    x: number;
                    y: number;
                    value: number;
                    index: number;
                    width: number;
                  };
                  if (index !== activeIndex) return null;
                  return (
                    <>
                      <text
                        x={x + width / 2}
                        y={y - 18}
                        textAnchor="middle"
                        fill="#39CA88"
                        fontSize={12}
                        fontWeight={700}
                      >
                        {value}
                      </text>
                      <circle
                        cx={x + width / 2}
                        cy={y - 2}
                        r={6}
                        fill="#39CA88"
                        stroke="#272C42"
                        strokeWidth={2}
                      />
                    </>
                  );
                }}
              />
            </Bar>
          </ReBarChart>
        </ResponsiveContainer>
      </Box>
    </ChartCardContainer>
  );
};
